/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAccessControlRequest = {
  agentId: string;
};

/** @internal */
export type GetAccessControlRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetAccessControlRequest$outboundSchema: z.ZodType<
  GetAccessControlRequest$Outbound,
  z.ZodTypeDef,
  GetAccessControlRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getAccessControlRequestToJSON(
  getAccessControlRequest: GetAccessControlRequest,
): string {
  return JSON.stringify(
    GetAccessControlRequest$outboundSchema.parse(getAccessControlRequest),
  );
}
